import React from "react";

import {
  HeaderComponent,
  TrackingErrors,
  ProgressBar,
  FooterComponent,
  ShipmentInputComponent,
  ShipmentCurrentStatusComponent,
  Navbar,
  FAQComponent,
  ShipmentNonTrackableErrorComponent,
} from "../../Components";
import "./home-container.scss";

export const HomeContainer: React.FC = () => {

  return (
    <div className='home-container-wrapper'>
      <Navbar />
      <HeaderComponent />
      <div className='home-container m-auto pt-md-5 pt-3 px-2 px-lg-0'>
        <ShipmentInputComponent />
        <ShipmentNonTrackableErrorComponent />
        <TrackingErrors />
        <ProgressBar />
        <ShipmentCurrentStatusComponent />
        {/* @TODO Removed as per WEBSCAN-266 Should be enabled again when the marketing team is ready */}
        {/* <ShipmentStatusesComponent /> */}
        <FAQComponent />
      </div>
      <div className='footer-wrapper'>
        <FooterComponent />
      </div>
    </div>
  );
};
